import React from 'react';
import { Container, Box, Grid, Typography, Link } from '@mui/material';
import Divider from '@mui/material/Divider';

const PRWIP = () => {
  return (
    <Container maxWidth="md">
            <Box m={2}>
        <Grid container spacing={3} justify="center">
          <Grid item xs={12}>
          </Grid>
        </Grid>
        <Grid container spacing={2} justify="center">
          <Grid item xs={12}>
            <Typography variant="h4" align="center" style={{margin: '16px 0', fontWeight: 'bold' }}>
              Introducing Scott Stevenson: Empowering California Lawyers with Web3 Legal Engineering Education
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              For more information about Web3 Legal Engineering and Scott Stevenson's CLE course, please visit&nbsp;
              <a href="https://web3legaltools.com/">
                https://web3legaltools.com/
              </a>.
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="h4" align="center" style={{margin: '16px 0', fontWeight: 'bold' }}>
              About Web3 Legal Engineering:
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              Web3 Legal Engineering is a consortium of legal professionals and lawyers committed to pioneering the development of legal systems in the digital age. The mission is to facilitate a seamless transition from traditional legal practices to emerging technologies and paradigms. Web3 Legal Engineering provides cutting-edge legal services, education, and consultancy in the context of blockchain, decentralized systems, and Web3 technologies found at&nbsp;
              <a href="https://lexautomatico.com">
                LexAutomatico
              </a> and&nbsp;
              <a href="https://smartlaw.freeweb3.com">
                SmartLaw.freeweb3.com
              </a>.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              <a href="https://freeweb3.infura-ipfs.io/ipfs/QmcJrKaxYbKvGc1T4X1Nn9H5T6Vd3s5WNEkTP9jJ2oCnpF" target="_blank">
              VIDEO GRID AND HTML IFRAMES
              </a>
            </Typography>
          <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              <a href="https://freeweb3.infura-ipfs.io/ipfs/QmUifF26WhMXqd2PbNLLZQShjdFNvdGmGZK8gGmfMntgtU" target="_blank">
              HTML GRID
              </a>
            </Typography>
            <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              <a href="https://freeweb3.infura-ipfs.io/ipfs/QmdYUDrYyTLhRmsfE22d6r2zvgfpkNYcsAYXrJkmKJjfwV" target="_blank">
              VIDEO GRID SIDE BY SIDE
              </a>
            </Typography>
            <Typography variant="body1" paragraph style={{ textAlign: 'left'}}>
              <a href="https://freeweb3.infura-ipfs.io/ipfs/QmV4jnFyppreEu7a6A5M5sKRn5Bvz5eGAk8ueWwvudoeU5" target="_blank">
              VIDEO GRID
              </a>
            </Typography>

          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default PRWIP;
